import { render, staticRenderFns } from "./k-grid-pagination.vue?vue&type=template&id=5dad684d&scoped=true"
import script from "./k-grid-pagination.vue?vue&type=script&lang=js"
export * from "./k-grid-pagination.vue?vue&type=script&lang=js"
import style0 from "./k-grid-pagination.vue?vue&type=style&index=0&id=5dad684d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dad684d",
  null
  
)

export default component.exports